import type { PartnerTransactionType } from '@models/partner';
import type { UiMeta } from './uiMeta';
import { getUiMeta, toLabelMap } from './uiMeta';

export const PARTNER_TRANSACTION_TYPE_META = {
  PAID_ORDER: {
    label: 'Purchase',
    chip: { color: 'error', variant: 'outlined' },
    order: 1,
  },
  REFUNDED_ORDER: {
    label: 'Refund',
    chip: { color: 'info', variant: 'filled' },
    order: 2,
  },
  DEPOSIT: {
    label: 'Deposit',
    chip: { color: 'success', variant: 'filled' },
    order: 3,
  },
  WITHDRAW: {
    label: 'Withdraw',
    chip: { color: 'warning', variant: 'filled' },
    order: 4,
  },
} as const satisfies Record<PartnerTransactionType, UiMeta>;

export const PARTNER_TRANSACTION_TYPE_LABELS = toLabelMap(
  PARTNER_TRANSACTION_TYPE_META,
);

export const getPartnerTransactionTypeMeta = (
  type?: PartnerTransactionType | string | null,
) => getUiMeta(PARTNER_TRANSACTION_TYPE_META, type);
